import React from 'react'
import './ContactUs.css'
import BannerComponent from '../Common-Component/BannerComponent/BannerComponent'
import ContactUsForm from './ContactUsForm/ContactUsForm'

const ContactUs = () => {
    return (
        <section className='ContactUs'>
            <BannerComponent img="\assets\Images\ContactUs\banner.png" title="Contact Us" />


            <div className='contact_card_holder'>

                <div className='container'>
                    <div className='row me-0 ms-0'>
                        <div className='col-lg-9'>
                            <div className='contact_form_div'>
                                <ContactUsForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}

export default ContactUs
